import React from "react";
import style from "../../assets/css/components/Input/CheckPlayer.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTshirt } from "@fortawesome/free-solid-svg-icons";
import { useField } from "formik";

function CheckPlayer({ player, value, ...props }) {
  const [field, meta] = useField(props);

  return (
    <div className={style.item}>
      <label className={style.option}>
        <input {...field} {...props} type="checkbox" value={value} />
        <span className={style.checkmark}>
          <FontAwesomeIcon icon={faTshirt} />
          <p className={style.title}>{player}</p>
        </span>
      </label>
      {meta.touched && meta.error && (
        <p className={style.txtWarning}>{meta.error}</p>
      )}
    </div>
  );
}

export default CheckPlayer;
